<template>
  <div class="result">
    <random v-if="type == 2" :id="testid"  :type="type"/>
    <dimensionality :id="testid" v-if="type == 3" :type="type"/>
    <grade v-if="type == 1" :id="testid"  :type="type"/>
  </div>
</template>

<script>
import random from './components/random.vue'; // 分数结果
import dimensionality from './components/dimensionality.vue'; // 维度
import grade from './components/grade.vue'; // 随机结果
export default {
    data(){
        return{
            testid:null,
            type:null
        }
    },
    components: { random,dimensionality,grade },
    created(){
        // 获取 URL 哈希
    const hash = window.location.hash;
    const params = new URLSearchParams(hash.slice(hash.indexOf("?") + 1));
    this.testid = params.get("id");
    this.type = params.get('type');

    console.log(this.testid,this.type );
    },

}
</script>

<style>

</style>